---
nb:
  activerecord:
    attributes:
      api/key:
        company_ids: Bedriftstilgang
        description: Beskrivelse
        name: Navn
        token: Token
      asset_comment:
        content: Melding
        period: Periode
        periods:
          monthly: Månedlig
          quarterly: Kvartalsvis
          yearly: Årlig
        power_plant_id: Kraftverk
      bilateral_data:
        kaia_trade_metric_name: Kaia Trade metric-navn
        ownership_share: Eierandel
      budget_forecast:
        avg_price: Gjennomsnittspris
        price_area: Prisområde
        volume_percent: Volumprosent
      company:
        availability_analysis_enabled: Tilgjengelighetsanalyse aktivert
        benchmarking: Benchmarking aktivert
        business_id: Business ID
        commercial_scada_enabled: Kommersiell SCADA aktivert
        detect_water_loss_downtime_enabled: Oppdagelse av vanntapsnedetid aktivert
        environmental_flow_tracking_enabled: Miljøstrømovervåking aktivert
        follow_up_enabled: Oppfølging aktivert
        liquidity_planning_enabled: Likviditetsplanlegging aktivert
        market_outlook_enabled: Markedsutsikter aktivert
        om_dashboard_enabled: Operatørside aktivert
        ppa_pricing_enabled: PPA Prising aktivert
        remove_logo: Fjern logo
        task_management_enabled: Oppgavestyring aktivert
        url_facebook: Facebook
        url_homepage: Hjemmeside
        url_instagram: Instagram
        url_linked_in: LinkedIn
        white_labeling: White labeling aktivert
      company_responsible:
        power_plants: Kraftverk
        responsible: Ansvarlig
      contract:
        active: Aktiv
        counterpart: Motpart
        end_date: Kontraktsluttdato
        open_ended: Kontrakt på ubestemt tid
        power_plant: Kraftverk
        power_plants: Kraftverk
        start_date: Kontraktsstartdato
        type: Kontrakstype
      downtime_event:
        comment: Kommentar
        component: Hovedkomponent
        ends_at: Slutt periode
        insurance: Forsikringssak
        power_plant_id: Kraftverk
        reason: Årsak
        starts_at: Start periode
        total: Totalt
        verified: Verifisert
        volume: Volum
        volume_hint: Gjennomsnittlig utilgjengelig kapasitet per time
        volume_set_manually: Sett volum manuelt
        volume_should_have_been: Gjennomsnittlig timesvolum i tidsperioden
      event:
        active: aktiv
        alarm_categories: Alarmkategorier
        component: Komponent
        duration: Lengde
        ends_at: Til
        energy_loss_mwh: Energitap (MWh)
        operational_status: Status
        starts_at: Fra.
        unavailable_power_kw: Utilgjengelig kraft (kW)
        yield_loss: Tap ({currency})
      fall_lease:
        amount: Beløp
        code: Kode
        description: Beskrivelse
        month: Måned
        owner: Eier
        period: Periode
        year: År
      feature_request:
        author: Forfatter
        category: Kategori
        date: Dato lagt til
        status: Status
        title: Tittel
        upvotes: Stemmer
      feed_in_tariff_data:
        limit_type: Begrensningstype
        limit_types:
          fixed_price: Fast pris
          price: Pris
        limit_value: Grenseverdi
      hedging_data:
        limit_type: Begrensningstype
        limit_types:
          percent: Prosent
          volume: Volum
        limit_value: Grenseverdi
        price: Pris
        strategies:
          monthly: Månedlig
          pay_as_produced: Pay as Produced
          quarterly: Kvartalsvis
          yearly: Årlig
        strategy: Strategi
      hydro/asset:
        bypass_valve: Omløpsventil
        concession_date: Konsesjonsdato
        pipe_rupture_valve: Rørbruddsventil
        river_name: Elv
        start_stop_power_fraction: Start/stopp-effektandel
        start_stop_power_fraction_hint: Effektendring som andel av merkeeffekt innen 15 min som markerer start/stopp
        winter_closed: Vinterstengt
      hydro/environmental_flow_breakpoints:
        day: Minstevannsdag
        flow: Minstevannføring
      hydro/generator:
        effect_limitation: Ekstern begrensning
        efficiency_percent: Effektivitet
        installed_capacity_mva: Kapasitet [MVA]
        power_factor_percent: Effektfaktor
      hydro/intake:
        dam_length: Damlengde [m]
        dam_width_streamwise: Dambredde [m]
        intake_type: Inntakstype
        lat: Lat
        lng: Lng
        lower_alert_limit: Nedre varslingsgrense
        masl: Inntak [m.o.h.]
        trash_rack_cleaner: Grindrenser
        upper_alert_limit: Øvre varslingsgrense
        upstream_depth: Oppstrøms dybde [m]
      hydro/model_param:
        bypass_max: Forbislipp maks
        bypass_min: Forbislipp min
        continuous_dispatch: Kontinuerlig kjøring
        discharge_max: Vannføring maks
        discharge_min: Vannføring min
        energy_deviation_threshold: Terskel for energiavvik
        energy_equivalent: Energiekvivalent
        net_head_masl_bound_max: Netto fallhøyde grense maks (moh.)
        net_head_masl_bound_min: Netto fallhøyde grense min (moh.)
        overflow_protection: Overløpsbeskyttelse
        p_max_overflow: Maks produksjon ved overløp
        production_max: Maksimumsproduksjon
        production_min: Minimumsproduksjon
        production_min_runtime_hours: Driftstid ved minimumslast
        production_sensitivity_max: Produksjonssensitivitet maks
        production_sensitivity_min: Produksjonssensitivitet min
        resample_to: Resampling til
        reservoir_max_masl: Magasin maks (moh.)
        reservoir_min_masl: Magasin min (moh.)
        reservoir_target_percentage: Magasinmål
        runoff_scale_factor: Skaleringsfaktor for tilsig
        startup_override_production: Overstyrt oppstartsproduksjon
        use_runoff_data: Bruk tilsigsdata
      hydro/penstock:
        diameter: Diameter
        length: Lengde
        material: Materiale
        net_head_loss_percent: Netto falltap
        risk_category: Risikokategori
      hydro/precipitation_field:
        aborigines: Urbefolkning
        area: Område
        avg_flow_area: Gjennomsnittlig vannmengde
        field_length: Feltlengde
        forest_size_percent: Skogsstørrelse
        glacier_size_percent: Brestørrelse
        lat: Breddegrad
        lng: Lengdegrad
        mountain_size_percent: Fjellstørrelse
        sea_size_percent: Sjøstørrelse
        swamp_size_percent: Myrstørrelse
      hydro/reservoir:
        artificial_reservoir: Kunstig reservoar
        gross_dammed_area: Brutto oppdemmet areal
        gross_power_density: Brutto effekttetthet
        highest_reservoir_value: Høyeste reservoarverdi [m.o.h.]
        lat: Breddegrad
        lng: Lengdegrad
        lowest_reservoir_value: Laveste reservoarverdi  [m.o.h.]
        name: Navn
        net_dammed_area: Netto oppdemmet areal
        net_power_density: Netto effekttetthet
        reservoir_name: Reservoarnavn
        reservoir_volume: Reservoarvolum
        risk_category: Risikokategori
        surface_area: Overflateareal
      hydro/river:
        anadromous_fish: Anadrom fisk
        name: Navn
        river_gradient: Elvegradient
        river_length: Elvelengde
        watercourse: Vassdrag
        watercourse_area: Vassdragsområder
      hydro/transformer:
        capacity_mva: Kapasitet [MVA]
        effect_limitation: Effektbegrensning
        efficiency_percent: Effektivitet
      hydro/turbine:
        efficiency_percent: Virkningsgrad (ved nominelle forhold)
        efficiency_percent_short: Virkningsgrad
        installed_effect_mw: Kapasitet [MW]
        masl: Turbin [m.o.h.]
        max_throughput_operational: Maks driftsvannføring
        min_throughput_operational: Minste driftsvannføring
        q_min_loss_percent: Q min loss
        turbine_type: Turbintype
      label:
        color: Farge
        name: Navn
      news_item:
        accessible_by: Relatert til
        allow_comments: Tillat kommentarer
        author: Forfatter
        body: Innhold
        category: Kategori
        community_access: Community innlegg
        companies: Selskaper
        date: Dato
        image: Bilde
        image_position: Bildeposisjon
        include_subsidiaries: Inkluder datterselskaper
        internal_post_landowner_access: Grunneiertilgang
        portfolio_access: Portefølje
        posts:
          one: Innlegg
          other: Innlegg
        power_plants: Kraftverk
        title: Tittel
      nve_metadata:
        building_type: Bygningstype
        building_types:
          surface: I dagen
          surface_underground: I fjell/dagen
          underground: I fjell
        bypasswater_downstream_powerplant_label: Forbitapping til neste kraftverk (NVE ref. nr.)
        date_inital_utilization_of_waterfall: Dato for første utnyttelse av fallet
        date_oldest_power_producing_part: Dato for eldste kraftproduserende del
        energy_equivalent: Energiekvivalent [KWh/m^3]
        floodwater_downstream_powerplant_label: Flomvann til neste kraftverk (NVE ref. nr.)
        min_throughput: Minste slukevne
        min_throughput_unit: Minste slukevne [m^3/s]
        nve_bypasswater_downstream_powerplant: Forbitapping til neste kraftverk
        nve_floodwater_downstream_powerplant: Flomvann til neste kraftverk
        nve_production_downstream_powerplant: Produksjons- vann til neste kraftverk
        powerplant_type: Type kraftverk
        powerplant_types:
          reservoir: Magasinkraftverk
          run_of_river: Elvekraftverk
        precipitation_area: Nedbørsfelt
        production_downstream_powerplant_label: Produksjons- vann til neste kraftverk (NVE ref. nr.)
        regine_nr: Reginenr
        sp_nr_point_reference: SP-punk
        sp_nr_watercourse: SP-vassdrag
      power_plant:
        absorption_capacity: Maks gjennomstrømning
        asset_class: Type kraftverk
        axpo_id: Axpo ID
        bazefield_site_id: Bazefield site ID
        biodiversity_sensitive_areas: Biodiversitetsfølsomme områder
        climate_future_ref: Climate future referanse
        co2_emission: CO2-utslipp
        collect_weather: Hent vær data
        commissioning_date: Idriftsettelsesdato
        company_id: Selskap
        company_name: Company name
        continuous_forecast_enabled: Kontinuerlig prognose aktivert
        country_id: Land
        county: Fylke
        county_name: Fylkesnavn
        datastream: Datastrøm
        day_ahead_forecast_enabled: Prognose for neste dag aktivert
        downtime_analysis: Nedetidsanalyse
        ecs_id: ECS ID
        elcert: Elsert
        elcert_ends_on: Sluttdato elsertifikater
        elcert_starts_on: Startdato elsertifikater
        external_id: Nest ID
        forecast_query_enabled: Aktiver videresending av produksjonsplan
        forecasted_budget: Prognostisert budsjett
        generator_capacity_mva: Generatorkapasitet [MVA]
        go_date: GO utløpsdato
        greenbyte_site_id: Greenbyte site ID
        grid_owner: Netteier
        gurusoft_tags: Gurusoft tags
        image: Last opp bilde
        image_attribution: Bildeattribusjon
        in_operation: I drift
        intake_count: Ant. inntak
        intake_lat_lng: Inntakskoordinater
        internal_notes: Interne notater
        kaia_uuid: Kaia UUID
        krasys_live_measurement_values: KRASYS live måleverdier
        kwh_m3: Energiekvivalent
        lat: Breddegrad
        lng: Lengdegrad
        max_effect: Hist. maks effekt
        max_throughput_operational: Maks driftsvannføring
        metering_point_id: Metering point ID
        min_operational_power: Min. driftseffekt [MW]
        min_production_effect: Nedetidsterskel [MW]
        min_throughput_operational: Minste driftsvannføring
        model_parameters: Modellparametere
        municipality: Kommune
        municipality_name: Kommunenavn
        name: Navn
        net_head_masl: Netto fallhøyde [m.o.h.]
        nispera_id: Nispera ID
        num_segments: Antall segmenter
        nve_gwh: Årsproduksjon
        nve_nr: NVE-nr
        nve_status: Status
        optimization_model: Optimaliseringsmodell
        owner: Eier
        periods: Perioder
        plant_effect_mw: Kraftverkskapasitet [MW]
        postcode: Postkode
        price_area: Prisområde
        price_dependent_bid_override: Overskrive prisavhengig budverdi
        production_simulation_plan_enabled: Simulering av produksjonsplan aktivert
        project: Prosjekt
        rated_power_mw: Turbinkapasitet [MW]
        remove_image: Fjern bilde
        reservoir: Magasin
        scada_int_id: Scada Internasjonal ID
        scada_int_tag: Scada Internasjonal tag
        settled_volume_source: Kilde avregnet volum
        shadow_testing: Skyggetesting
        shadow_tracking: Skyggesporing
        site_address: Kraftverksadresse
        station_lat_lng: Stasjonskoordinater
        statkraft_customer_id: Statkraft kunde-ID
        turbine_count: Ant. turbiner
        turbine_level_masl: Turbinhøyde [m.o.h.]
        turbine_type: Turbintype
        unsettled_volume_source: Kilde ikke-avregnet volum
        use_price_dependent_bid: Bruk prisavhengig bud
        vertical_drop: Netto fallhøyde
        weather_source: Værkilde
        wikipedia_page_id: Wikipedia artikkel ID
        xledger_project_id: Xledger Prosjekt ID
        yearly_production: Normal produksjon [GWh]
      power_plant_responsible:
        company_responsible: Ansvarlig
        role_values:
          accounting: Accounting
          asset_manager: Asset Manager
          auditor: Auditor
          balancing_responsible: Balancing Responsible
          ceo: CEO
          guarantees_of_origin_sales: Guarantees of origin sales
          hv_leader: Høyspent driftsleder
          insurance_broker: Insurance Broker
          internal_grid_om: Internal Grid O&M
          internet_provider: Internet Provider
          operator: D&V ansvarlig
          owner_representative: Owner representative
          plant_supervisor: Stedlig personell
          road_maintenance: Road Maintenance
          snow_ploughing: Snow Ploughing
          substation_om: Substation O&M
          turbine_om: Turbine O&M
          vta: VTA
          waste_management: Waste Management
        roles: Roller
      responsible:
        email: E-post
        name: Navn
        phone: Telefon
        user_id: Bruker
      scheduled_downtime_event:
        comment: Kommentar
        component: Hovedkomponent
        curtailed_mode: Begrenset modus
        ends_at: Slutt periode
        operator_email: Operatørens e-post
        power_plant_id: Kraftverk
        reason: Årsak
        starts_at: Start periode
        volume: Volum
        volume_hint: Gjennomsnittlig utilgjengelig kapasitet per time
      self_consumption_data:
        currency_code: Valuta
        generator_auxiliary_consumption_price_mwh: Generator hjelpeforbrukskostnad per MWh
        grid_injection_price_mwh: Nettinnmating per MWh
        grid_injection_spot: Nettinnmating ved spotpris
        self_consumption_price_mwh: Egetforbrukspris per MWh
      sensor:
        lower_alert_limit: Nedre varslingsgrense
        upper_alert_limit: Øvre varslingsgrense
      solar/asset:
        anomaly_thresholds_help: 'Behold standardinnstillinger for deteksjon av anomalier med <code>&#123;&quot;idc&quot;:null,&quot;udc&quot;:null,&quot;fuac&quot;:null,&quot;min_gpoa_availability_wm2&quot;:60.0&#125;</code>.<br /> Mulig full tilpasning med standardinnstillinger:'
        anomaly_thresholds_raw: Terskelverdier for anomaliteter
        avg_yearly_solar_radiation: Gjennomsnittlig årlig solstråling
        data_source_settings_help: 'Innstillinger for datakilde i json-format. Obligatorisk attributt: <code>type</code> for å definere datakilden.<br /> Se <a href="https://github.com/kaia/captiva_portal/wiki/Solar-data-source-settings.">Kaia portal wiki</a> for flere innstillinger.<br /> Eksempel for Solar-Log FTP:'
        data_source_settings_raw: Datakildeinnstillinger
        full_operating_hours: Fullasttimer
        ml_learning_parameters_help: 'Minimale innstillinger uten invertere eller MPPT-erstatninger: <code>&#123;&quot;timestamp_from&quot;:&quot;2023-01-01T00:00:00Z&quot;,&quot;timestamp_to&quot;:&quot;2024-01-01T00:00:00Z&quot;,&quot;inv_replacements&quot;:[],&quot;mppt_replacements&quot;:[]&#125;</code>.<br /> Eksempel med komponenterstatninger:'
        ml_learning_parameters_raw: Maskinlæringsparameter
        storage_unit_present: Batterilagringssystem til stede
        substation_lat: Transformatorstasjon lat
        substation_lng: Transformatorstasjon lng
        substation_masl: Transformatorstasjon [m.o.h.]
      solar/field:
        installed_power_kwp: Installert effekt
        module_efficiency_percent: Modulvirkningsgrad
        mounting_mode: Innfestingsmetode
        mounting_modes:
          freestanding: Frittstående (fri luftsirkulasjon)
          fully_insulated: Fullisolert bakside
          intermediary: Innfelt (begrenset luftsirkulasjon)
        name: Navn
        orientation: Orientasjon
        tilt: Vinkel
      solar/inverter:
        external_id: Mapping av datakilde
        installed_power_kwp: Installert effekt
        modules_count: Antall moduler
        name: Navn
        signal_mapping_raw: Signal mapping
        solar_inverter_type_id: Type vekselretter
        valid_from: Gyldig fra
        valid_to: Gyldig til
      solar/inverter_type:
        maximal_power_kva: Maks synlig effekt
        model: Modell
        mppt_count: Antall MPPT'er
        nominal_power_kw: Nominell aktiv effekt
        supplier: Leverandør
        supplier_id: ID
      solar/model_param:
        production_max: Maksimumsproduksjon
        production_min: Minimumsproduksjon
        production_sensitivity_max: Produksjonssensitivitet maks
        production_sensitivity_min: Produksjonssensitivitet min
      solar/module_type:
        alpha_isc: Temperaturkoeffisient for ISC Alpha
        beta_uoc: Temperaturkoeffisient for Uoc Beta
        cell_type: Celleteknologi
        cells_in_series: Celler i serie
        current_impp_a: MPP Ampere
        current_isc_a: Kortslutningsstrøm
        gamma_pmpp: Temperaturkoeffisient for Pmpp Gamma
        length_mm: Rammelengde
        model: Modell
        module_efficiency: Moduleffiktivitet
        noct_degc: Nominell driftscelletemperatur NOCT
        power_pmpp_w: Nominell effekt
        supplier: Leverandør
        supplier_id: ID
        system_voltage_v: Maks systemspenningk
        voltage_umpp_v: MPP Volt
        voltage_uoc_v: Åpen kretsspenning
        width_mm: Rammebredde
      solar/mppt:
        input_number: Inngangsnummer
        installed_power_kwp: Installert effekt
        modules_efficiency: Moduleffiktivitet
        modules_in_series: Moduler i serie
        modules_surface_m2: Overflateareal tilkoblede moduler
        signal_mapping_raw: Signalmapping
        solar_field_id: Solfelt
        solar_module_type_id: Nest solmodul
        source_name: Datakilde
        stringbox_name: SCB name
        strings_in_parallel: Strenger i parallell
      spot_data:
        ownership_share: Eierandel
      supplier:
        add_new: Legg til ny leverandør
        category: Kategori
        type: Type
        url_facebook: Facebook
        url_homepage: Hjemmeside
        url_instagram: Instagram
        url_linked_in: LinkedIn
      user:
        avatar: Avatar
        avatar_lowercase: avatar
        company_ids: Selskaper
        currency_code: Valuta
        email: E-post
        firstname: Fornavn
        job_title: Stillingstittel
        lastname: Etternavn
        locale: Portalspråk
        news_email: Ukentlige nyhetsmeldinger
        password: Passord
        password_confirmation: Bekreft passord
        phone: Telefon
        power_plant_ids: Kraftverk
        short_bio: Kort bio
      wind/asset:
        activity: Aktivitet
        avg_yearly_wind_speed: Gjennomsnittlig årlig vindhastighet
        data_source_settings_raw: Datakildeinnstillinger
        full_operating_hours: Fullasttimer
        recycle_share_percent: Resirkuler andel
        substation_lat: Substation lat
        substation_lng: Substation lng
        substation_masl: Substation [m.o.h.]
      wind/availability_calculation:
        contractual_availability_calculation: Kontraktsmessig tilgjengelighetsberegning
        contractual_availability_energy_based: Kontraktsmessig tilgjengelighet
        energy_based_availability: Energibasert tilgjengelighet
        time_based_availability: Tidsbasert tilgjengelighet
      wind/availability_mapping:
        alarm_category: Alarmkategori
        alarm_category_types:
          environmental: Miljø
          force_majeure: Force Majeure
          grid: Nett
          manufacturer: Leverandør
          no_data: Ingen data
          owner: Eier
          turbine_ok: Turbin OK
        contractual_availability: Kontraktsmessig tilgjengelighet
        mapping_types:
          neglected: Oversett
          ready: Klar
          unavailable: Ikke tilgjengelig
        total_availability: Total tilgjengelighet
      wind/availability_target:
        contractual_availability_target: Kontraktsmessig tilgjengelighet mål
        year: År
      wind/event_mappings:
        alarm_category_type: Type alarmkategori
        turbine_event_code: Kode for turbinhendelse
        turbine_event_name: Turbinhendelsesnavn
      wind/model_param:
        production_max: Maksimumsproduksjon
        production_min: Minimumsproduksjon
        production_sensitivity_max: Produksjonssensitivitet maks
        production_sensitivity_min: Produksjonssensitivitet min
      wind/power_curve:
        air_density_kgm3: Lufttetthet
        default: Standard
        file: Fil
        historical_power_curve: Historisk effektkurve
        manufacturer_power_curve: Leverandørens effektkurve
        name: Navn
        power: Kraft
        power_kw: Kraft [kW]
        show: Vis kraftkurve
        title: Kraftkurve
        wind_speed: Vindhastighet
        wind_speed_ms: Vindhastighet [m/s]
      wind/turbine:
        commissioning_year: Idriftsettelsesår
        external_source_id: ID Ekstern datakilde
        ground_altitude_masl: Bakkehøyde [m.o.h.]
        hub_height: Navhøyde
        lat: Latitude
        lng: Longitude
        name: Navn
        tip_height: Totalhøyde
        wind_turbine_type_id: Vindturbintype
      wind/turbine_type:
        meteomatics_id: Meteomatics turbin-ID
        name: Navn
        rated_power_kw: Nominell kraft [kW]
        rotor_diameter: Rotordiameter [m]
        supplier_id: ID
      work_item:
        budget_cost: Budsjett kostnad
        closed_on: Stengt den
        company_responsible: Ansvarlig
        component: Hovedkomponent
        description: Beskrivelse
        due_date: Tidsfrist
        elapsed_cost: Forløpt kostnad
        forecast_cost: Prognosekostnad
        id: ID
        labels: Etiketter
        last_comment: Siste kommentar
        power_plant: Kraftverk
        started_on: Startet den
        status: Status
        title: Tittel
        valuta: Valuta
    errors:
      models:
        budget_forecast:
          volume_forecast: må være mellom 0 og 100
        contract:
          too_long: Må være kun ett kraftverk
        event:
          cannot_change_component_or_operation_status_settled: Kan ikke endre komponent eller operasjonell_status_id for en avgjort, ikke-avsluttet hendelse.
          cannot_delete_settled: Kan ikke slette en avgjort hendelse
          cannot_modify_locked_event: Kan ikke endre en låst hendelse.
          cannot_overlap: Overlappende hendelser for den samme komponenten er ikke tillat.
          cannot_update_settled: Kan ikke oppdatere en avgjort/avsluttet hendelse.
        market_paramaeter:
          bids_illogical: Minste budpris kan ikke være større enn maks budpris
    models:
      elcert_month:
        one: Elsert måned
        other: Elcert måneder
      go_month:
        one: GoO måned
        other: GoO måneder
